module.exports = __webpack_public_path__ + "assets/pizza-f7b888.svg";